export default {
	subtitle: "Confirm 3DS Credit Card Transaction in Chile",
  path: "transaction_cc_chl_confirmation",
	paragraphs: ["When your customer is prompted for an OTP (one-time password), the transaction you created in the previous step will be held on pending until this step is done. Once that OTP is entered and confirmed, this endpoint needs to be called in the sequence.", "If the process is successfully complete, you will have an 'identified' status transaction. Otherwise, it will be canceled. In this case you can check what happened in the 'errors' or 'payment_failed' field.", "Note: if you are using the HTML sample page, this part will be done automatically and any errors will be presented on the feedback section, on the upper part of the page.", "Notice that in sandbox, this scenario can be simulated by making a transaction greater than 3000 CLP."],
  request: {
    method: "POST",
    endpoint: "/transactions/:id/confirm_threeds",
    responses: {
      "data": {
        "value": "30000",
        "to_bank_account": {
          "routing_number": "021000021 - Special instruction: SFTB000001",
          "pix_info": null,
          "owner_name": null,
          "owner_document_type": null,
          "owner_document_number": null,
          "owner_company": {
            "social_name": "POWER HOME THEATER",
            "id": "f64e512c-1a81-42d9-9ac9-05f369bc98e3",
            "document_type": "tax_id",
            "document_number": "2348909854385"
          },
          "nickname": null,
          "intermediary_bank_account": null,
          "id": "4af245f8-de8b-45f5-8ba7-58003d325b12",
          "iban": null,
          "currency": "USD",
          "branch_number": null,
          "branch_country": "CHL",
          "bank": {
            "swift": "CHASUS33",
            "name": "JPMorgan Chase Bank",
            "ispb": null,
            "id": "e6a25c9c-e5f2-49db-a24e-c8710a18b6a8",
            "country": null,
            "code": null
          },
          "account_type": "conta-corrente",
          "account_number": "10000344906926",
          "aba": null
        },
        "subject_is_receiver": false,
        "subject_id": "4a42a549-09fa-489f-a22a-3557d2323443",
        "subject": {
          "updated_at": "2025-07-10T22:02:08.671256",
          "status": "approved",
          "social_name": "Muñoz Perez",
          "required_clearance_level": 1,
          "phone_number": "675675",
          "phone_country_code": "32",
          "phone_area_code": "56",
          "net_value": "0.00",
          "net_monthly_average_income": "0.00",
          "natural_person": true,
          "main_activity": null,
          "inserted_at": "2025-02-14T12:15:40.779049",
          "id": "4a42a549-09fa-489f-a22a-3557d2323443",
          "fiscal_country": "Chile",
          "email": "munoz.isidro@gmail.com",
          "document_type": "rut",
          "document_number": "112934596",
          "creation_date": "1994-09-18",
          "company_type": "ltda",
          "company_name": "Muñoz Perez",
          "clearance_level": 1,
          "address_street": "Parcela 1 Sector Huaqui Los Angeles",
          "address_state": "PQ",
          "address_postal_code": "64345",
          "address_number": "2251",
          "address_neighborhood": "Santa Ines",
          "address_country": "Chile",
          "address_complement": null,
          "address_city": "Sausalito",
          "activity_type": "outros"
        },
        "status": "identified",
        "source_name": "Muñoz Perez",
        "source_document_type": "rut",
        "source_document_number": "112934596",
        "meta": null,
        "inserted_at": "2025-07-10T22:02:08.659847",
        "id": "151e99e5-67c2-4e66-94c1-01849d8e8c43",
        "from_credit_card": {
          "status": "tokenized",
          "masked_card_number": "445652******0255",
          "inserted_at": "2025-07-10T22:02:08.658377",
          "id": "1c56114f-9805-480a-a46c-5782005ba6c9"
        },
        "from_bank_account": null,
        "for_exchange": true,
        "exchange_under_request": false,
        "exchange_currency": "USD",
        "estimated_value_until_exchange": false,
        "currency": "CLP",
        "cleared": true,
        "bank_transaction": {
          "wire_id": null,
          "value": "30000.0",
          "spei_reference": null,
          "spei_concepto_de_pago": null,
          "source_type": "CREDIT CARD",
          "source_name": "Muñoz Perez",
          "source_id": "151e99e5-67c2-4e66-94c1-01849d8e8c43",
          "source_document_type": "rut",
          "source_document_number": "112934596",
          "source_description": "PAGAMENTO POR CARTAO",
          "source_branch": null,
          "source_bank_ispb": null,
          "source_bank": null,
          "source_account": null,
          "movement_date": "2025-07-10",
          "iof_value": null,
          "inserted_at": "2025-07-10T22:02:22.411691",
          "id": "455987dd-605f-493f-811f-251a32da1689",
          "exchanged_value": null,
          "exchange_rate_spot": null,
          "exchange_rate": null,
          "exchange_id": null,
          "exchange_currency": "USD",
          "exchange_approved": false,
          "currency": "CLP"
        }
      }
    }
  },
  headersPayload: [
    {
      name: "id",
      type: "string",
      required: true,
      description: "ID of the transaction created in the previous step"
    }
  ],
  parameterPayload: [
    {
      name: "payment_id",
      type: "string",
      required: true,
      description: "ID you received in the query params"
    },
  ],
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/CreditCardCHLConfirmation.js